"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdSchema = void 0;
const zod_1 = require("zod");
const UserIdSchema = zod_1.z.object({
    userId: zod_1.z.string(), // Keycloak UUID
});
exports.UserIdSchema = UserIdSchema;
